import { axiosWithAuth } from "helpers";

export const merchantAdditionalServices = {
	getAdditionalServices,
	editAdditionalServices,
};

const API_URL = process.env.REACT_APP_API_URL;

function getAdditionalServices(merchantId: string) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/merchants/${merchantId}/additional_services`,
	};

	return axiosWithAuth(options);
}

function editAdditionalServices({ merchantId, formValues }) {
	const options = {
		method: "POST",
		data: formValues,
		url: `${API_URL}/api/merchants/${merchantId}/additional_services`,
	};

	return axiosWithAuth(options);
}
